<template>
  <div class="about">
    <Draggable />
  </div>
</template>

<script>
// @ is an alias to /src
import Draggable from '@/components/Draggable.vue'

export default {
  name: 'ABOUT',
  components: {
    Draggable,
  }
}
</script>
